import Select from 'react-select';
import { LOCALES } from 'utils/languageUtils';

const FormikSelect = ({ field, form, options, isLoading, language }) => (
  <Select
    classNamePrefix="select"
    className="react-select"
    menuPlacement="bottom"
    options={options}
    getOptionLabel={(opt) => (language === LOCALES.ENGLISH ? opt?.en : opt?.el)}
    getOptionValue={(it) => it?.value}
    isLoading={isLoading}
    isDisabled={form.isSubmitting || isLoading}
    isSearchable={false}
    value={field.value}
    onChange={(value) => {
      field.onChange({ target: { name: field.name, value: value } });
      form.setFieldError(field.name, undefined);
    }}
    onBlur={() => {
      field.onBlur({ target: { name: field.name } });
    }}
  />
);

export default FormikSelect;
